import React, { Component, MouseEvent, ReactNode } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import Icon from '../../icons/Icon';

class CustomOperationComponent extends Component<Props> {
  private actionRef: OverlayPanel | null = null;
  private div: HTMLDivElement | null = null;
  public render(): ReactNode {
    const { items } = this.props;
    return (
      <div ref={(r) => (this.div = r)} className='fill-f-black-3 hover:fill-f-black-3'>
        <span onClick={this.toggleOverlay}>
          <Icon className={'text-f-black-3'} icon={'overlay-menu'} size={20} />
        </span>
        <OverlayPanel ref={(ref) => (this.actionRef = ref)} style={{}} dismissable>
          {items.map((item, index) => (
            <div
              key={index}
              onClick={(e: MouseEvent<HTMLDivElement>) => {
                this.toggleOverlay(e);
                item.onClick(e);
              }}
              className='p-2 text-left font-normal text-2xs cursor-pointer hover:bg-background-1 rounded'
            >
              {item.title}
            </div>
          ))}
        </OverlayPanel>
      </div>
    );
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  private handleOutsideClick = (e: any) => {
    if (e.target != this.div) {
      this.actionRef?.hide();
    }
  };

  private toggleOverlay = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    this.actionRef?.toggle(e);
  };
}

export type CustomOperationItem = {
  title: string | ReactNode;
  onClick: (e: MouseEvent) => void;
};

interface Props {
  items: CustomOperationItem[];
}

export default CustomOperationComponent;
